import type { FC } from 'react';

import ExoticsRiskBandContent from './exotics-risk-band-content';
import type { ExoticsRiskBandProps } from './types';

const ExoticsRiskBandWidget: FC<ExoticsRiskBandProps> = ({ instrumentId }) => (
  <ExoticsRiskBandContent instrumentId={instrumentId} />
);

export default ExoticsRiskBandWidget;
